import css from "./PaymentForm.module.css";
import { useT } from "~/util/Lang";
import { InfoBox } from "../ui/InfoBox";
import { useState } from "react";
import { Link } from "react-router";
import dayjs from "dayjs";
import { TrackerButton, TrackerPaymentButton } from "./links/TrackerButton";

type User =
  | {
      login: string;
      timezone: string | null;
      subscriptionExpiry: string | null;
    }
  | undefined;

export function PaymentForm(params: { user: User }) {
  const { user } = params;
  const [state, setState] = useState<"free" | "monthly" | "yearly">("free");
  const t = useT();

  const cost = { free: 0, monthly: 200, yearly: 2000 };

  const subIsActive = user
    ? dayjs(user.subscriptionExpiry).diff(dayjs()) > 0
    : false;

  return (
    <InfoBox title={t({ en: "Payment", ru: "Оплата" })}>
      {user ? (
        subIsActive ? (
          <div>
            <div>
              {t({
                en: "The subscription is valid until:",
                ru: "Подписка действует до:",
              })}
            </div>
            <div>{dayjs(user.subscriptionExpiry).format("YYYY-MM-DD")}</div>
            <div style={{ marginTop: 20 }}>
              <TrackerButton auth={true} />
            </div>
            <div>
              <TrackerPaymentButton
                hash={btoa(`userId=${params.user?.login}&period=month`)}
              />
            </div>
          </div>
        ) : (
          <div style={{ padding: "0 7px" }}>
            <div className={css.root}>
              <label htmlFor="plan-free" className={css.label}>
                <input
                  id="plan-free"
                  type="radio"
                  value={state}
                  checked={"free" === state}
                  onChange={(e) => setState("free")}
                />
                {t({
                  en: "Free - Trial for two weeks",
                  ru: "Free - Бесплатно 2 недели",
                })}
              </label>
              <label htmlFor="plan-monthly" className={css.label}>
                <input
                  id="plan-monthly"
                  type="radio"
                  checked={"monthly" === state}
                  onChange={(e) => setState("monthly")}
                />
                <div>
                  {t({ en: "Monthly - ", ru: "На месяц - " })}
                  <strong>{t({ en: "200₽", ru: "200₽" })}</strong>
                </div>
              </label>
              <label htmlFor="plan-yearly" className={css.label}>
                <input
                  id="plan-yearly"
                  type="radio"
                  checked={"yearly" === state}
                  onChange={(e) => setState("yearly")}
                />
                <div>
                  {t({ en: "Yearly - ", ru: "На год - " })}
                  <strong>{t({ en: "2000₽", ru: "2000₽" })}</strong> -{" "}
                  <span style={{ color: "#48bb78" }}>
                    {t({ en: "save 200₽ per year", ru: "Выгоднее на 200₽" })}
                  </span>
                </div>
              </label>
              <button className={css.button}>{cost[state]} ₽</button>
            </div>
          </div>
        )
      ) : (
        <div style={{ padding: "0 7px" }}>
          {t({
            en: "To purchase a subscription, you must log in or register.",
            ru: "Для приобретения подписки необходимо авторизоваться или зарегистрироваться.",
          })}
          <div
            style={{
              display: "flex",
              gap: 10,
              marginTop: 20,
            }}
          >
            <Link to={"/login"} className={css.loginButton}>
              Login
            </Link>
            <Link to={"/Register"} className={css.registerButton}>
              Register
            </Link>
          </div>
        </div>
      )}
    </InfoBox>
  );
}
